import { CHECKMARK, CIRCLE, HEART, SMILE, STAR, THUMB_UP } from '../constants/scaleShapes';

export const isShapeCheckmark = (shape) => shape === CHECKMARK.value;

export const isShapeCircle = (shape) => shape === CIRCLE.value;

export const isShapeHeart = (shape) => shape === HEART.value;

export const isShapeSmile = (shape) => shape === SMILE.value;

export const isShapeStar = (shape) => shape === STAR.value;

export const isShapeThumbUp = (shape) => shape === THUMB_UP.value;
